























import Vue from "vue";

export default Vue.extend({
    name: "InlinesQuestions",
    props: {
        // Default (50%), small (33%)
        questionASize: {
            type: String,
            required: false,
            default: ""
        },
        questionBSize: {
            type: String,
            required: false,
            default: ""
        },
        questionCSize: {
            type: String,
            required: false,
            default: ""
        }
    },
});

